// F2-a: store sessione owner (solo UI-state). La verita' della sessione e'
// il cookie HttpOnly `hm_owner_at` lato cloud; questo store serve a sapere
// se mostrare la dashboard o redirigere a /owner/login senza un roundtrip.
// Persistito su localStorage cosi' al refresh la UI owner non sfarfalla.
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { OwnerInfo } from '../api/owner.js';

type OwnerState = {
  owner: OwnerInfo | null;
  setOwner: (owner: OwnerInfo | null) => void;
  clear: () => void;
};

export const useOwnerSession = create<OwnerState>()(
  persist(
    (set) => ({
      owner: null,
      setOwner: (owner) => set({ owner }),
      clear: () => set({ owner: null }),
    }),
    {
      name: 'hm-owner-session',
      partialize: (s) => ({ owner: s.owner }),
    },
  ),
);
